import { getCycles } from './ciclosEscolares';

/**
 * Obtiene el ciclo escolar vigente (periodo actual) según la fecha de hoy.
 * @returns {Promise<Object|null>} El ciclo vigente o null si no hay.
 */
export async function getPeriodoActual() {
  const ciclos = await getCycles();
  const hoy = new Date();
  // Buscar ciclo donde hoy esté entre fecha_inicio y fecha_fin y estado_ciclo sea ACTIVO
  const vigente = ciclos.find(c => {
    if (!c.fecha_inicio || !c.fecha_fin) return false;
    const inicio = new Date(c.fecha_inicio);
    const fin = new Date(c.fecha_fin);
    return (
      inicio <= hoy && hoy <= fin &&
      (c.estado_ciclo === 'ACTIVO' || c.activo)
    );
  });
  return vigente || null;
}
